window.__lsUpsellSync = window.__lsUpsellSync || (function () {
  async function sync (cartData, cartItemID = null) {
    try {
      let cart = cartData;
      const updateQuantity = window?.themeVariables?.settings?.upsell?.updateQuantity ?? false;
      if (!cart) {
        const res = await fetch(window.themeVariables.routes.cart_url, {
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) {
          console.warn('[UpsellSync] /cart.js failed with status', res.status);
          return;
        }
        cart = await res.json();
      }

      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;

      const items = cart.items;
      const mainQtyByProductId = Object.create(null);
      const upsellLines = [];

      for (const line of items) {
        const productId = Number(line.product_id);
        if (!Number.isNaN(productId)) {
          if (!mainQtyByProductId[productId]) mainQtyByProductId[productId] = 0;
          mainQtyByProductId[productId] += line.quantity;
        }

        const props = line.properties || {};
        const rawMainId = props._ls_upsell_for_product_id;

        if (rawMainId) {
          const mainId = Number(rawMainId);
          if (!Number.isNaN(mainId)) {
            upsellLines.push({
              cartLineId: line.id,
              currentQty: line.quantity,
              cartLineKey: line.key,
              mainProductId: mainId,
            });
          }
        }
      }

      if (!upsellLines.length) {
        return;
      }

      const isUpsell = cartItemID && upsellLines.some(l => l?.cartLineKey === cartItemID);

      const updates = {};
      let hasChanges = false;

      for (const line of upsellLines) {
        const mainQty = mainQtyByProductId[line.mainProductId] || 0;
        if (isUpsell) {
          const cappedQty = Math.min(line.currentQty, mainQty);
          if (cappedQty !== line.currentQty) {
            updates[line.cartLineId] = cappedQty;
            hasChanges = true;
          }
        } else {
          let needleUpdate;
          if (updateQuantity) {
            needleUpdate = (mainQty !== line.currentQty);
          }else{
            needleUpdate = mainQty < line.currentQty;
          }
          if (needleUpdate) {
            updates[line.cartLineId] = mainQty;
            hasChanges = true;
          }
        }
      }

      if (!hasChanges) return;

      let sectionsToBundle = [];
      try {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          }),
        );
      } catch (e) {
        console.warn('[UpsellSync] cart:prepare-bundled-sections error:', e);
      }

      const formData = new FormData();
      Object.keys(updates).forEach((lineId) => {
        formData.append(`updates[${lineId}]`, String(updates[lineId]));
      });

      if (sectionsToBundle && sectionsToBundle.length) {
        sectionsToBundle.forEach((sectionId) => {
          formData.append('sections', sectionId);
        });
      }

      const resUpdate = await fetch(window.themeVariables.routes.cart_update_url, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      if (!resUpdate.ok) {
        console.warn('[UpsellSync] /cart/update.js failed with status', resUpdate.status);
        return;
      }

      let updatedCart = null;
      let responseJson = null;

      try {
        responseJson = await resUpdate.json();
      } catch (e) {
        console.warn('[UpsellSync] resUpdate.json() failed:', e);
      }

      try {
        const resCart = await fetch(window.themeVariables.routes.cart_url, {
          headers: { Accept: 'application/json' },
        });

        if (resCart.ok) {
          const cartContent = await resCart.json();
          if (responseJson && responseJson.sections) {
            cartContent.sections = responseJson.sections;
          } else if (!cartContent.sections) {
            cartContent.sections = {};
          }
          updatedCart = cartContent;
        }
      } catch (e) {
        console.warn('[UpsellSync] fallback /cart.js failed:', e);
      }

      if (!updatedCart || !Array.isArray(updatedCart.items)) {
        return;
      }

      try {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'ls:upsell-sync',
              cart: updatedCart,
            },
          }),
        );
      } catch (e) {
        console.warn('[UpsellSync] cart:change dispatch error:', e);
      }

      try {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {
        console.warn('[UpsellSync] cart:refresh dispatch error:', e);
      }
    } catch (e) {
      console.warn('[UpsellSync] sync error:', e);
    }
  }

  return {
    sync,
  };
})();

(function () {
  if (!window.fetch) return;
  if (window.__lsUpsellFetchWrapped) return;
  window.__lsUpsellFetchWrapped = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    const url =
      typeof input === 'string'
        ? input
        : (input && input.url) || '';

    let method = 'GET';
    if (init && init.method) {
      method = init.method;
    } else if (input && typeof input === 'object' && input.method) {
      method = input.method;
    }

    const isCartChange =
      !!url &&
      !!method &&
      method.toUpperCase() === 'POST' &&
      window.themeVariables &&
      window.themeVariables.routes &&
      window.themeVariables.routes.cart_change_url &&
      url.indexOf(window.themeVariables.routes.cart_change_url) !== -1;

    const p = originalFetch(input, init);

    if (!isCartChange) {
      return p;
    }

    return p.then((response) => {
      if (!response || !response.ok) {
        return response;
      }

      try {
        const cloned = response.clone();
        cloned.json().then((data) => {
          const cartData =
            data && data.cart && Array.isArray(data.cart.items)
              ? data.cart
              : data;

          if (
            cartData &&
            Array.isArray(cartData.items) &&
            window.__lsUpsellSync &&
            typeof window.__lsUpsellSync.sync === 'function'
          ) {
            const body = init && init.body;
            let cartItemID = null;

            if (body && typeof body === 'string' && body.trim().startsWith('{')) {
              try {
                const obj = JSON.parse(body);
                cartItemID = obj.id;
              } catch (e) {}
            }

            window.__lsUpsellSync.sync(cartData, cartItemID);
          }
        }).catch((e) => {
          console.warn('[UpsellSync] change response .json() error:', e);
        });
      } catch (e) {
        console.warn('[UpsellSync] response.clone() error:', e);
      }

      return response;
    });
  };
})();
